/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{max-height:95vh}.carousel-item img{height:100%;width:auto;max-height:75vh;cursor:zoom-in}span.carousel-control-next-icon,span.carousel-control-prev-icon{background-color:rgba(110,110,110,.15)}"];
export { styles as styles };
